import type { SharedConfig } from 'core/domains/config';

const sharedConfig: SharedConfig = {
  app: {
    environment: process.env.REACT_APP_ENV,
    mediaRatio: 661 / 834,
    url: 'http://localhost:8002',
    version: process.env.REACT_APP_VERSION || '',
  },
  formCreditCard: {
    baseUrl: 'https://hportais-payment.vd.grupoboticario.com.br',
  },
};

if (process.env.REACT_APP_ENV === 'development') {
  sharedConfig.formCreditCard.baseUrl = 'http://localhost:3001';
}

if (process.env.REACT_APP_ENV === 'development' || process.env.NODE_ENV === 'test') {
  sharedConfig.app.url = 'http://localhost:8002';
}

if (process.env.REACT_APP_ENV === 'production') {
  sharedConfig.formCreditCard.baseUrl = 'https://portais-payment.vd.grupoboticario.com.br';
}

export { sharedConfig };
